import React from "react";
import { Calendar, Laptop } from "react-bootstrap-icons";

function TimetablePreview() {
  const weekRange = "06/10/2025 to 12/10/2025";
  const data = {
    Monday: [
      { id: 1, name: "Karate", time: "10am to 11am" },
      { id: 2, name: "Test Session", time: "1pm to 1:30pm" },
      { id: 3, name: "Test Session", time: "4pm to 4:30pm" },
    ],
    Tuesday: [
      { id: 4, name: "Pilates", time: "11am to 12pm" },
      { id: 5, name: "Test Session", time: "3pm to 3:30pm" },
    ],
    Wednesday: [{ id: 6, name: "Karate", time: "11:59am to 12pm" }],
    Thursday: [],
    Friday: [{ id: 7, name: "Yoga", time: "10am to 11am" }],
    Saturday: [],
    Sunday: [],
  };

  const DayCol = ({ title, items }) => {
    if (!items.length) return null;
    return (
      <div className="col">
        <div className="card shadow-sm">
          <div className="card-header text-center bg-white">
            <div className="fs-5 fw-semibold">{title}</div>
          </div>
          <div className="list-group list-group-flush">
            {items.map((x) => (
              <div key={x.id} className="list-group-item text-center">
                <div className="fw-semibold">{x.name}</div>
                <div className="mb-2">{x.time}</div>
                <button className="btn btn-outline-primary rounded-pill px-4 btn-sm">
                  Book now
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="border rounded p-3 bg-light">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div className="fw-bold fs-5">Weekly timetable</div>
        <div className="text-muted">{weekRange}</div>
        <div className="d-flex gap-3">
          <button className="btn btn-link p-0">Previous</button>
          <button className="btn btn-link p-0">Next</button>
        </div>
      </div>

      <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-3">
        <DayCol title="Monday" items={data.Monday} />
        <DayCol title="Tuesday" items={data.Tuesday} />
        <DayCol title="Wednesday" items={data.Wednesday} />
        <DayCol title="Thursday" items={data.Thursday} />
        <DayCol title="Friday" items={data.Friday} />
        <DayCol title="Saturday" items={data.Saturday} />
        <DayCol title="Sunday" items={data.Sunday} />
      </div>
    </div>
  );
}

function MembershipPreview() {
  const subs = [
    {
      id: 1,
      name: "Basic Membership",
      price: "£14.40",
      interval: "Monthly",
      desc: "Access to all classes",
    },
    {
      id: 2,
      name: "Family Membership",
      price: "£29.00",
      interval: "Monthly",
      desc: "Two adults and two juniors",
    },
  ];
  const passes = [
    {
      id: 3,
      name: "10 Class Pass",
      price: "£55.00",
      token: 10,
      desc: "Use any time",
    },
    {
      id: 4,
      name: "5 Class Pass",
      price: "£30.00",
      token: 5,
      desc: "Use any time",
    },
  ];

  return (
    <div className="border rounded p-3 bg-light">
      <div className="mb-3">
        <div className="fw-bold fs-5 mb-2">Subscriptions</div>
        <div className="list-group">
          {subs.map((p) => (
            <div key={p.id} className="list-group-item">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1 fw-semibold">{p.name}</h6>
                  <small className="text-muted">
                    {p.interval} recurring payment
                  </small>
                </div>
                <span className="badge text-bg-dark fs-6">{p.price}</span>
              </div>
              <div className="text-muted small mt-2">{p.desc}</div>
              <div className="mt-3">
                <button className="btn btn-primary btn-sm">Subscribe</button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-4">
        <div className="fw-bold fs-5 mb-2">Flexible Class Passes</div>
        <div className="list-group">
          {passes.map((p) => (
            <div key={p.id} className="list-group-item">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1 fw-semibold">{p.name}</h6>
                  <small className="text-muted">Classes: {p.token}</small>
                </div>
                <span className="badge text-bg-dark fs-6">{p.price}</span>
              </div>
              <div className="text-muted small mt-2">{p.desc}</div>
              <div className="mt-3">
                <button className="btn btn-primary btn-sm">Buy</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function WidgetInfoModal({ cancelModal }) {
  return (
    <div className="fullscreen-modal-overlay">
      <div className="fullscreen-modal">
        <div className="blueBanner">
          <p className="fw-bold m-2 p-2 fontSize20">Membotic Widgets</p>
        </div>

        <div className="container py-4">
          <h2 className="fw-bold text-center mb-4">What Are Widgets</h2>
          <hr />

          <div className="mb-4">
            <h4 className="fw-bold">
              Add your class timetable to your website
            </h4>
            <p>
              Place your live Membotic timetable directly onto your website.
              Visitors can see upcoming sessions right away without needing to
              log in or go anywhere else.
            </p>
            <TimetablePreview />
          </div>

          <hr />

          <div className="mb-4">
            <h4 className="fw-bold">Show membership options</h4>
            <p>
              Add a simple price list widget so visitors can instantly see your
              joining options and choose the plan that suits them.
            </p>
            <MembershipPreview />
          </div>

          <hr />
          <div className="my-4">
            <h2 className="h3 fw-bold mb-2">Take bookings and payments</h2>
            <p className="  mb-4">
              Add a booking button to your site. Visitors select a class and are
              redirected to Membotic to complete booking and payment.
            </p>

         
          </div>

          <hr />

          <div className="mb-4">
            <h4 className="fw-bold">How it works</h4>
            <p>
              Each widget comes with a short code snippet. Copy it into your
              website (WordPress, Wix, Squarespace, or custom site) and it
              instantly connects to your Membotic account. No extra setup
              needed.
            </p>
            <p>
              Widgets are included in the £14.40 monthly plan, giving your club
              a professional edge while keeping everything simple.
            </p>
          </div>
        </div>

        <button
          type="button"
          className="close-button"
          onClick={cancelModal}
          aria-label="Close"
        >
          &times;
        </button>

        <div className="send-modal-footer">
          <button
            onClick={cancelModal}
            className="pointer cancelButton fw-bold mx-2 px-3"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
